/*
 * @Author: jiansuiwang@rastar.com
 * @Date: 2023-08-17 15:59:55
 * @LastEditors: jiansuiwang@rastar.com
 * @LastEditTime: 2023-12-01 16:54:44
 * @FilePath: \sea-page-game\src\views\info\index.js
 */
import Vue from "vue";
import Tpl from "./template.vue";
import Toast from "../../components/toast";
import Base from "../../utils/base";
import Report from "../../utils/report";
import generalMethod from "../../utils/generalMethod";
import SyModel from "../../models/sy";
import Storage from "../../utils/storage";
import Ciphertext from "../../utils/Ciphertext";
import VueI18n from "vue-i18n";

import "../../assets/style/main.scss";
import "../../registerServiceWorker";

Vue.prototype.$Toast = Toast;
Vue.prototype.$Base = Base;
Vue.prototype.$Report = Report;
Vue.prototype.$generalMethod = generalMethod;
Vue.prototype.$Storage = Storage;
Vue.prototype.$Ciphertext = Ciphertext;
Vue.prototype.$SyModel = SyModel;
Vue.use(Toast);
Vue.use(Base);
Vue.use(Report);
Vue.use(generalMethod);
Vue.use(Storage);
Vue.use(Ciphertext);
Vue.use(SyModel);
Vue.use(VueI18n);
const navLang = navigator.language || navigator.userLanguage;
let localLang = "en-US"; //本地开发语言包
let lang = navLang || "en-US"; //实际语言包
const i18n = new VueI18n({
  locale: lang ? lang : localLang, // 语言标识，
  messages: {
    en: require("./../../config/languages/en"),
    zh: require("./../../config/languages/zh"),
    es: require("./../../config/languages/es"),
  },
});
new Vue({
  i18n,
  render: (h) => h(Tpl),
  created() {
    if (lang.substring(0, 2) == "zh") {
      i18n.locale = "zh";
    } else if (lang.includes("es")) {
      i18n.locale = "es";
    } else {
      i18n.locale = "en";
    }
    localStorage.setItem("lang", i18n.locale);
  },
}).$mount("#rastar");
